// @flow

const RE_DATE = /([0-9]{4})-([0-9]{2})-([0-9]{2})/;

export function formatDueDate(stringDate: string): string {
  const matchObj = RE_DATE.exec(stringDate);
  if(!matchObj)
    throw new Error('Voucher: invalid payload due date format');

  const month = matchObj[2];
  const day = matchObj[3];

  return `${day}/${month}`;
}
